import { useEffect, useState } from 'react';

/**
 * 画像がデコードまで終わって「今すぐ描ける」状態かを返す。
 *
 * `background-image` に URL を渡しただけだと、ブラウザは取得が終わった瞬間から
 * 描き始める。バナーのような大きな画像だと**上から順に出る / 一瞬白く抜ける**が起き、
 * さらにその上に載っているスクリムと合成が食い違って帯に見える。
 *
 * `img.decode()` の解決を待ってから背景を当て、CSS のトランジションで重ねれば
 * 「出来上がった絵が現れる」に見える。
 *
 * url が null のとき(画像未設定)は待つものが無いので即 true。
 * 差し替え中は false に戻さない — 戻すと前の絵が消えて一瞬下地が見える。
 * 新しい絵が準備できた時点で上から差し替わればよい。
 */
export const useImageReady = (url: string | null): boolean => {
  const [readyUrl, setReadyUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!url) return;
    let cancelled = false;

    const img = new Image();
    img.src = url;
    // decode() 未対応や失敗(CORS 等)でも「準備できた」に倒す。
    // ここで詰まると画像が永久に出ないので、待てないなら待たない。
    const done = () => { if (!cancelled) setReadyUrl(url); };
    (img.decode?.() ?? Promise.resolve()).then(done).catch(done);

    return () => { cancelled = true; };
  }, [url]);

  return url === null || readyUrl === url;
};
